



import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class Label extends Vue {
  @Prop({ default: '' }) field!: string
  @Prop({ default: '' }) text!: string
}
